module.exports = __webpack_public_path__ + "img/warning.d2bf7ef7.svg";